import { Container, Stack, Typography } from '@mui/material'

import { FunctionComponent } from 'react'
import DevelopersBanner from 'src/components/DevelopersBanner'
import BulletedList from 'src/components/BulletedList'

const Home: FunctionComponent = () => {
  return (
    <Container maxWidth="md">
      <Stack spacing={3} m={6}>
        <Typography variant="h4">👋 Welcome to the Angaza Developer Portal!</Typography>

        <DevelopersBanner />
      </Stack>
      <Typography>
        Here you can find resources for all of Angaza's developer oriented products,
        allowing you to power up your Angaza platform with straightforward and flexible data solutions.
        We offer two main developer-oriented product suites:
      </Typography>

      <BulletedList
        items={[
          'The Angaza Connects suite, intended for Angaza customers who use the Hub and Activator and are looking to build integrations on top of these products.',
          'The Angaza Nexus suite, intended for Angaza manufacturing partners and external platforms, focused on enabling device integrations with the Angaza platform.'
        ]}
      />
    </Container>
  )
}

export default Home
